import { AsyncPipe, NgForOf, NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { NavController } from '@ionic/angular';
import { TranslocoModule } from '@ngneat/transloco';
import { Store } from '@ngrx/store';
import { TuiLetModule, tuiPure } from '@taiga-ui/cdk';
import { TuiButtonModule } from '@taiga-ui/core';
import { ENVIRONMENT } from '@us/app-config';
import {
    Cart,
    CartActions,
    selectCart,
    selectCartTotalNewItems,
    selectLoading,
    selectOrderType
} from '@us/web/cart/data-access';
import { BusinessModel, OrderState, OrderType } from '@us/web/shared/data-access';
import { isFnBApp, RouteUtil } from '@us/web/shared/utils';
import { FormatCurrencyPipe, selectBusinessModels } from '@us/web/shop/data-access';
import { isNil } from 'lodash';
import {filter, map, Observable, of, switchMap} from 'rxjs';

@Component({
    selector: 'us-cart-checkout-btn',
    standalone: true,
    imports: [TuiButtonModule, TranslocoModule, NgIf, AsyncPipe, TuiLetModule, NgForOf, RouterLink, FormatCurrencyPipe],
    templateUrl: './cart-checkout-btn.component.html',
    styleUrls: ['./cart-checkout-btn.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CartCheckoutBtnComponent {
    @Input() cart!: Cart;

    private readonly env = inject(ENVIRONMENT);
    private readonly store = inject(Store);
    private readonly navController = inject(NavController);

    cart$: Observable<Cart> = this.store.select(selectCart);
    loading$: Observable<boolean> = this.store.select(selectLoading);
    totalNewItems$: Observable<number> = this.store.select(selectCartTotalNewItems);

    businessModels$ = this.store.select(selectOrderType).pipe(
        switchMap(orderType => {
            if (orderType !== OrderType.OrderAtTheTable) {
                return of([BusinessModel.PrePayment]);
            }
            return this.store.select(selectBusinessModels).pipe(
                map(items => items.filter(item => item !== BusinessModel.NoMenuDisplayed))
            );
        })
    );

    readonly BusinessModel = BusinessModel;

    readonly isFnBApp = isFnBApp(this.env);

    readonly OrderState = OrderState;

    @tuiPure
    isPayLater(businessModel: BusinessModel): boolean {
        return Number(businessModel) === BusinessModel.PayLater;
    }

    async submitOrder(businessModel: BusinessModel) {
        if (isNil(businessModel) || businessModel === BusinessModel.PayLater) {
            this.store.dispatch(CartActions.submitCart({ businessModel }));
        } else {
            await this.navController.navigateForward(RouteUtil.getCartCheckoutRouteUrl());
            // const modal = await this.modalCtrl.create({
            //     component: CartCheckoutComponent,
            //     componentProps: { businessModel }
            // });
            // return await modal.present();
        }
    }
}
